<template>
  <div class="card-body text-primary">
    <confirm-modal id="modal-password-form"></confirm-modal>
    <h4>Email ändern</h4>
    <form @submit.prevent="persistMail()" class="form">
      <div class="form-group">
        <label for="settingsInputEmail">Email-Adresse</label>
        <input
          type="email"
          class="form-control"
          id="settingsInputEmail"
          :placeholder="oldEmail"
          name="settings.email"
          v-model="email.email"
        />
        <small class="form-text text-muted"
          >Wir teilen deine Email-Adresse nicht mit anderen Mitgliedern. Wir
          senden an deine neue E-Mail-Adresse eine E-Mail zur Verifizierung.
          Wenn du auf den Link klickst, wissen wir, dass diese existiert und
          erreichbar ist. Erst dann wird deine neue E-Mail-Adresse von uns
          übernommen.</small
        >
      </div>
      <div class="form-group">
        <label for="settingsInputPassword">Aktuelles Passwort</label>
        <input
          type="password"
          class="form-control"
          id="settingsInputPassword"
          placeholder="Passwort"
          autocomplete="current-password"
          name="settings.password"
          v-model="email.currentPassword"
        />
      </div>
      <button type="submit" class="btn btn-primary float-right">
        Email Speichern
      </button>
    </form>
    <h4>Passwort ändern</h4>
    <form @submit.prevent="persistPassword()">
      <div class="form-group">
        <label for="settingsInputPassword">Aktuelles Passwort</label>
        <input
          type="password"
          class="form-control"
          id="settingsInputPassword"
          placeholder="Passwort"
          autocomplete="current-password"
          name="settings.password"
          v-model="password.currentPassword"
        />
      </div>
      <div class="form-group">
        <label for="settingsInputPassword">Neues Passwort</label>
        <input
          type="password"
          class="form-control"
          id="settingsInputPassword"
          placeholder="Passwort"
          autocomplete="new-password"
          name="settings.password"
          v-model="password.password"
        />
      </div>
      <div class="form-group">
        <label for="settingsInputPassword">Neues Passwort wiederholen</label>
        <input
          type="password"
          class="form-control"
          id="settingsInputPassword"
          placeholder="Passwort"
          autocomplete="new-password"
          name="settings.password"
          v-model="password.password_confirmation"
        />
      </div>
      <div class="form-group">
        <button type="submit" class="btn btn-primary float-right">
          Passwort Speichern
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: {
        email: Laravel.user.email,
        currentPassword: ""
      },
      password: {
        currentPassword: "",
        password: "",
        password_confirmation: ""
      }
    };
  },
  computed: {
    oldEmail() {
      return Laravel.user.email;
    }
  },
  methods: {
    persistMail() {
      this.$http
        .patch(`/api/v1/user/${Laravel.user.id}`, { ...this.email })
        .then(() => {
          this.$notify({
            title: "Eine Bestätigungsemail wurde versendet",
            type: "success",
            group: "errors"
          });
        });
    },
    persistPassword() {
      this.$http
        .patch(`/api/v1/user/${Laravel.user.id}`, { ...this.password })
        .then(() => {
          this.$notify({
            title: "Ihr Passwort wurde geändert",
            type: "success",
            group: "errors"
          });
        });
    }
  }
};
</script>
